//#region src/master-languages.ts
var e = {
	af: {
		code: "af",
		name: "Afrikaans"
	},
	ar: {
		code: "ar",
		name: "Arabic"
	},
	bg: {
		code: "bg",
		name: "Bulgarian"
	},
	bn: {
		code: "bn",
		name: "Bengali"
	},
	cs: {
		code: "cs",
		name: "Czech"
	},
	cy: {
		code: "cy",
		name: "Welsh"
	},
	da: {
		code: "da",
		name: "Danish"
	},
	de: {
		code: "de",
		name: "German"
	},
	el: {
		code: "el",
		name: "Greek"
	},
	en: {
		code: "en",
		name: "English"
	},
	es: {
		code: "es",
		name: "Spanish"
	},
	et: {
		code: "et",
		name: "Estonian"
	},
	fa: {
		code: "fa",
		name: "Persian"
	},
	fi: {
		code: "fi",
		name: "Finnish"
	},
	fr: {
		code: "fr",
		name: "French"
	},
	gu: {
		code: "gu",
		name: "Gujarati"
	},
	he: {
		code: "he",
		name: "Hebrew"
	},
	hi: {
		code: "hi",
		name: "Hindi"
	},
	hr: {
		code: "hr",
		name: "Croatian"
	},
	hu: {
		code: "hu",
		name: "Hungarian"
	},
	id: {
		code: "id",
		name: "Indonesian"
	},
	is: {
		code: "is",
		name: "Icelandic"
	},
	it: {
		code: "it",
		name: "Italian"
	},
	ja: {
		code: "ja",
		name: "Japanese"
	},
	kn: {
		code: "kn",
		name: "Kannada"
	},
	ko: {
		code: "ko",
		name: "Korean"
	},
	lt: {
		code: "lt",
		name: "Lithuanian"
	},
	lv: {
		code: "lv",
		name: "Latvian"
	},
	mk: {
		code: "mk",
		name: "Macedonian"
	},
	ml: {
		code: "ml",
		name: "Malayalam"
	},
	mr: {
		code: "mr",
		name: "Marathi"
	},
	ne: {
		code: "ne",
		name: "Nepali"
	},
	nl: {
		code: "nl",
		name: "Dutch"
	},
	no: {
		code: "no",
		name: "Norwegian"
	},
	pa: {
		code: "pa",
		name: "Punjabi"
	},
	pl: {
		code: "pl",
		name: "Polish"
	},
	pt: {
		code: "pt",
		name: "Portuguese"
	},
	ro: {
		code: "ro",
		name: "Romanian"
	},
	ru: {
		code: "ru",
		name: "Russian"
	},
	sk: {
		code: "sk",
		name: "Slovak"
	},
	sl: {
		code: "sl",
		name: "Slovenian"
	},
	so: {
		code: "so",
		name: "Somali"
	},
	sq: {
		code: "sq",
		name: "Albanian"
	},
	sr: {
		code: "sr",
		name: "Serbian"
	},
	sv: {
		code: "sv",
		name: "Swedish"
	},
	sw: {
		code: "sw",
		name: "Swahili"
	},
	ta: {
		code: "ta",
		name: "Tamil"
	},
	te: {
		code: "te",
		name: "Telugu"
	},
	th: {
		code: "th",
		name: "Thai"
	},
	tl: {
		code: "tl",
		name: "Tagalog"
	},
	tr: {
		code: "tr",
		name: "Turkish"
	},
	uk: {
		code: "uk",
		name: "Ukrainian"
	},
	ur: {
		code: "ur",
		name: "Urdu"
	},
	vi: {
		code: "vi",
		name: "Vietnamese"
	},
	zh: {
		code: "zh",
		name: "Chinese (Simplified)"
	},
	"zh-Hant": {
		code: "zh-Hant",
		name: "Chinese (Traditional)"
	}
}, t = "en", n = (t) => e[t]?.name, r = (t) => t.map((t) => e[t]).sort((e, t) => e.name.localeCompare(t.name)), i = /* @__PURE__ */ "ar.bg.bn.cs.cy.da.de.el.en.es.et.fa.fi.fr.gu.he.hi.hr.hu.id.is.it.ja.ko.lt.lv.mk.mr.nl.no.pa.pl.pt.ro.ru.sk.sl.so.sq.sr.sv.sw.ta.te.th.tl.tr.uk.ur.vi.zh.zh-Hant".split("."), a = "en", o = r(i), s = /* @__PURE__ */ "ar.bg.cs.cy.da.de.el.en.es.et.fi.fr.he.hr.hu.is.it.ja.ko.lt.lv.nl.no.pl.pt.ro.ru.sk.sl.sr.sv.th.tr.uk.zh.zh-Hant".split("."), c = r(s), l = [
	"sq",
	"id",
	"fa",
	"vi"
], u = r([.../* @__PURE__ */ new Set([...s, ...l])]), d = /* @__PURE__ */ "ar.bg.cs.cy.da.de.el.en.es.et.fi.fr.he.hr.hu.is.it.ja.ko.lt.lv.nl.no.pl.pt.ro.ru.sk.sl.sr.sv.th.tr.uk.zh.zh-Hant".split("."), f = new Set(d), p = (e) => typeof e == "string" && f.has(e), m = r(d);
//#endregion
export { o as conversationLanguages, u as csatLanguages, a as defaultConversationLanguageCode, t as defaultLanguageCode, n as getLanguageName, p as isMessengerTranslatedLanguage, c as limitedSupportLanguages, m as messengerTranslatedLanguages };

//# sourceMappingURL=index.js.map